export const getStatusLabel = (p: any) => {
  if (p.aprobado && !p.pausado && !p.vencido) return "ACTIVO";
  if (p.aprobado && !p.pausado && p.vencido) return "VENCIDO";
  return "INACTIVO";
};
